import { Button } from 'src/components/design-system';
import { useTranslations } from 'next-intl';

interface Props {
  onClick: () => void;
}

export default function ModalContainerError(props: Props) {
  const t = useTranslations('loyalty');
  return (
    <div>
      <h2>{t('wallet.referral.modal.unlock')}</h2>

      <div className="tw-mb-8 tw-text-lg">
        {t('wallet.referral.modal.unlockExplanation')}
      </div>

      <div className="tw-flex tw-justify-between">
        <Button onClick={props.onClick}>{t('wallet.referral.modal.ok')}</Button>
      </div>
    </div>
  );
}
